<template>
  <div>
    <CrudList
      title="Cupones de Usuario"
      storeName="User_coupons"
      parentStoreName="Coupons"
      parentUrlKey="coupon_id"
      labelAddNew="Añadir usuario al cupon"
      :canAdd="true"
      :canEdit="false"
      :canDelete="true"
      labelBack="Atrás"
      sortable
      :breadcrumbs="[
        {
          text: 'Marketing y comunicación',
          disabled: false,
          href: '/admin/coupons'
        },
        {
          text: 'Cupones de Usuario',
          disabled: false,
          href: '#'
        },
        
      ]"
    >
      <template v-slot:created_at="{item}">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <p>{{ item.created_at ? formatDate(item.created_at) : '' }}</p>
          </v-col>
        </v-row>
      </template>
      <template v-slot:user_id="{ item }">
        <p>
          {{item && item.user_id?item.user_id.name:''}}
          {{item && item.user_id?item.user_id.last_name:''}}
          <br>
          {{item && item.user_id?item.user_id.email:''}}
        </p>
      </template>
      <template v-slot:coupon_id="{ item }">
        <p>
          {{item && item.coupon_id?item.coupon_id.title:''}}
          <br>
          {{item && item.coupon_id?item.coupon_id.description:''}}
        </p>
      </template>
    </CrudList>
  </div>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";
import CrudFormMixin from "@/mixins/crud_form";
export default {
  mixins: [CrudFormMixin],
  components: { CrudList },
  data: () => ({
    offsetTop: 0
  }),
  methods: {
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    }
  }
};
</script>
